import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col-12 lg:col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonCrudTable = _resolveComponent("SkeletonCrudTable")!
  const _component_Search = _resolveComponent("Search")!
  const _component_SearchDetail = _resolveComponent("SearchDetail")!

  return (!_ctx.hasData)
    ? (_openBlock(), _createBlock(_component_SkeletonCrudTable, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.showSearch)
              ? (_openBlock(), _createBlock(_component_Search, {
                  key: 0,
                  ref: "searchComp",
                  modelValue: _ctx.dataSearchFilter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataSearchFilter) = $event)),
                  catalogosData: _ctx.catalogos,
                  "onUpdate:catalogosData": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.catalogos) = $event)),
                  applicationId: _ctx.Component.applicationId,
                  applicationVersion: _ctx.Component.applicationVersion,
                  componentId: _ctx.Component.id,
                  dataSearch: _ctx.dataSearchResult,
                  "onUpdate:dataSearch": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataSearchResult) = $event)),
                  container: _ctx.container,
                  compDataSource: _ctx.datasource,
                  onBuscarDatos: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doRefreshData())),
                  onClosealltabs: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('closealltabs')))
                }, null, 8 /* PROPS */, ["modelValue", "catalogosData", "applicationId", "applicationVersion", "componentId", "dataSearch", "container", "compDataSource"]))
              : _createCommentVNode("v-if", true),
            (_ctx.dataSearchFilter.length > 0 || _ctx.showSearch == false)
              ? (_openBlock(), _createBlock(_component_SearchDetail, {
                  key: 1,
                  modelValue: _ctx.dataSearchResult,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataSearchResult) = $event)),
                  catalogosData: _ctx.catalogos,
                  "onUpdate:catalogosData": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.catalogos) = $event)),
                  rootParentId: _ctx.rootParentId,
                  Component: _ctx.Component,
                  compDataSource: _ctx.datasource,
                  container: _ctx.container,
                  editAllExceptKeys: _ctx.editAllExceptKeys,
                  showActionMenu: _ctx.showActionMenu,
                  filterTablas: _ctx.filterTables,
                  canAddNewItem: _ctx.canAddNewItem,
                  canImport: _ctx.canImport,
                  canUpdateMassive: _ctx.canUpdateMassive,
                  canDeleteItem: _ctx.canDeleteItem,
                  showActionDetail: _ctx.showActionDetail,
                  menuActionItems: _ctx.menuActionItems,
                  showSearch: _ctx.showSearch,
                  showPaginator: _ctx.showPaginator,
                  showHeaderDetail: _ctx.showHeaderDetail,
                  customAddNew: _ctx.customAddNew,
                  "onClick:action": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('click:action', $event))),
                  "onClick:viewDetail": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('click:viewDetail', $event))),
                  "onClick:SelectRow": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('click:SelectRow', $event))),
                  "onClick:addCustom": _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('click:addCustom',$event))),
                  "onClick:refreshData": _cache[11] || (_cache[11] = ($event: any) => (_ctx.doRefreshData()))
                }, null, 8 /* PROPS */, ["modelValue", "catalogosData", "rootParentId", "Component", "compDataSource", "container", "editAllExceptKeys", "showActionMenu", "filterTablas", "canAddNewItem", "canImport", "canUpdateMassive", "canDeleteItem", "showActionDetail", "menuActionItems", "showSearch", "showPaginator", "showHeaderDetail", "customAddNew"]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]))
}